
import React from 'react';
import WebDesignHero from '../WebHero/WebDesignHero';
import GraphicDesignHero from '../GraphicHero/GraphicDesignHero';

const Hero = ({ mode, mousePosition }) => {
  return (
    <div style={styles.container}>
      {/* Content based on mode */}
      {mode === 'web' ? <WebDesignHero mousePosition={mousePosition} /> : <GraphicDesignHero mousePosition={mousePosition} />}
    </div>
  );
};


const styles = {
  container: {
    background: '#0a0a0a',
    minHeight: '100vh',
    color: '#ffffff',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    overflow: 'hidden',
  },
};

export default Hero;
